var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.state.accessToken)?_c('div',{staticClass:"subscribe-section"},[_c('input',{staticClass:"mail-input",attrs:{"placeholder":"Votre e-mail...","type":"text"}}),_c('button',{staticClass:"main-button w-100"},[_vm._v("Adhérez")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }